import React from "react";
import { Helmet } from "react-helmet";

const Layout = ({ children }) => {
    const generalSchema = [
        {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "id": "https://tonaliteh.com/#corporation",
            "name": "Tonaliteh",
            "alternateName": ["Tonaliteh"],
            "legalName": "مرجع تخصصی چاپ و قاب آثار هنری ",
            "url": "https://tonaliteh.com/",
            "logo": "https://tonaliteh.com/images/Tonaliteh%20logo1.png",
            "email": "info@tonaliteh.com",
            "sameAs": ["https://www.instagram.com/tonaliteh.official/"],
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+989308860217",
                "contactType": "customer service",
                "areaServed": "IR",
                "availableLanguage": "Persian"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Tehran Province, No.6 Misaq , Jamshid Alley, No2",
                "addressLocality": "Tehran, Iran",
                "areaServed": {
                    "@context": "https://schema.org",
                    "@type": "Place",
                    "geo": { "@type": "GeoCoordinates", "latitude": "35.713225", "longitude": "51.435874" },
                    "hasMap": "https://maps.app.goo.gl/Ddm51AYP3N7pGVvK6"
                },
                "addressCountry": { "@type": "Country", "name": "Iran" }
            },
            "founders": [{ "@context": "https://schema.org", "@type": "Person" }],
            "jobTitle": "Chief executive officer",
            "name": "Atefeh Gholamin",
            "sameAs": ["https://www.linkedin.com/in/atefehgholamin/"],
            "@context": "https://schema.org",
            "@type": "WebSite",
            "id": "https://tonaliteh.com/#webSite",
            "name": "تونالیته",
            "url": "https://tonaliteh.com/",
            "copyrightHolder": {
                "@type": "Corporation",
                "id": "https://tonaliteh.com/#corporation",
                "name": "تونالیته"
            },
            "creator": {
                "@type": "Corporation",
                "id": "https://tonaliteh.com/#corporation",
                "name": "تونالیته"
            }
        }]

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(generalSchema)}
                </script>
            </Helmet>
            {children}
        </>
    );
};

export default Layout;
